import { logger } from '@/services/logger';
import { useAgentEditorStore } from '@/state/root';

export const useUpdateAgentLoader = () => {
    const agentEditorStore = useAgentEditorStore();

    return {
        showAgentLoader(text?: string) {
            try {
                window.DID_AGENTS_API?.showLoader?.(
                    text ?? 'Updating Agent...',
                    agentEditorStore.isPlaygroundLoaded ? 'blurred' : 'opaque'
                );
            } catch (e) {
                logger.warn('Failed to show agent loader', e);
            }
        },
        hideAgentLoader() {
            try {
                window.DID_AGENTS_API?.hideLoader?.();
            } catch (e) {
                logger.warn('Failed to hide agent loader', e);
            }
        },
    };
};
